import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { PhotographerForm } from './photographer.form';
import { IndirectUploadZoneComponent } from '../../../../../shared/form/element/indirect-upload-zone/indirect-upload-zone.component';
import { ColorFormat } from '../../../../../shared/form/element/colorpicker/colorpicker.component';

@Component({
  selector: 'admin-photographer-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class AdminPhotographerFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  @ViewChild('donePageUploader', { static: false })
  protected donePageUploader: IndirectUploadZoneComponent;

  @ViewChild('smilePageUploader', { static: false })
  protected smilePageUploader: IndirectUploadZoneComponent;

  @ViewChild('startPageUploader', { static: false })
  protected startPageUploader: IndirectUploadZoneComponent;

  @Input() row: any;
  @Input() selectedRowId: number;
  @Output() makeDefault = new EventEmitter();
  @Output() delete = new EventEmitter();
  isEditMode: boolean = false;

  fontStyles = {
    'Muli': 'Muli',
    'Georgia': 'Georgia',
    'Palatino Linotype': 'Palatino Linotype',
    // 'Times New Roman': 'Times New Roman',
    // 'Helvetica': 'Helvetica',
    // 'Arial': 'Arial',
    // 'Roboto': 'Roboto',
    // 'Impact': 'Impact',
    // 'Comic Sans MS': 'Comic Sans MS',
    // 'Lucida': 'Lucida Sans Unicode',
    // 'Tahoma': 'Tahoma',
    // 'Verdana': 'Verdana',
    // 'Courier New': 'Courier New',
    // 'Lucida Console': 'Lucida Console',
  };
  colorFormat: ColorFormat = 'HEX';

  constructor(formBuilder: PhotographerForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route);
  }

  ngOnInit() {
    super.ngOnInit();
    this.record = this.row;
    this.form.patchValue(this.row);
  }

  ngAfterViewInit() {
    if (this.row.id) {
      this.formMode = 'update';
      this.form.reset(this.row);
    } else {
      this.formMode = 'create';
    }
  }

  protected getUrl(forceId?: number): string {
    const params = this.route.snapshot.params;
    return '/admin/camera-theme' + (params.id ? `/${params.id}` : forceId ? `/${forceId}` : '');
  }

  protected onSubmit(response: any): void {
    this.editRow();
  }

  submit() {
    super.submit();
  }

  load(id: number) {
    this.loading = true;
    let url = this.getUrl(id);
    if (this.urlBuilder) {
      url = this.urlBuilder.buildUrl(url);
    }
    this.httpClient.get<any>(url)
      .subscribe(
        (data: any) => {
          this.row = data;
          if (data.logoFile) {
            this.onStartPageUploaded(data.logoFile);
          }
          if (data.bannerFile) {
            this.onSmilePageUploaded(data.bannerFile);
          }
          if (data.watermarkFile) {
            this.onDonePageUploaded(data.watermarkFile);
          }
          this.form.patchValue(this.row);
          this.loading = false;
        },
        (error: any) => {
          this.toastrService.error(error.message);
          this.loading = false;
        },
      );
  }

  editRow() {
    console.log(this.row);
    this.isEditMode = !this.isEditMode;
  }

  onStartPageUploaded(file: any) {
    this.row.startPageFile = file.fileName;
    this.row.startPageS3 = file.s3;
    this.form.controls['startPageFile'].setValue(file.fileName);
    this.form.controls['startPageS3'].setValue(file.s3);
  }

  onSmilePageUploaded(file: any) {
    this.row.smilePageFile = file.fileName;
    this.row.smilePageS3 = file.s3;
    this.form.controls['smilePageFile'].setValue(file.fileName);
    this.form.controls['smilePageS3'].setValue(file.s3);
  }

  onDonePageUploaded(file: any) {
    this.row.donePageFile = file.fileName;
    this.row.donePageS3 = file.s3;
    this.form.controls['donePageFile'].setValue(file.fileName);
    this.form.controls['donePageS3'].setValue(file.s3);
  }

}
